/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/procedimentosNormas/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from 'services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* findById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: `procedimentos-normas/${id}` });
    if (callback) {
      yield callback(response.data);
    } else {
      if (response.data && response.data.arquivos && response.data.arquivos.length > 0) {
        response.data.arquivos = yield FileService.downloadArquivos(response.data.arquivos);
      }
    }

    yield put({
      type: TypeActions.PROCEDIMENTOS_NORMAS_FIND_ONE_SUCCESS,
      data: response.data,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao recuperar as informações!'
    });
  }
}

function* create({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'procedimentos-normas', data: { ...data, arquivos: FileService.getArquivosToUpload(data.arquivos) } });
     yield put({
      type: TypeActions.PROCEDIMENTOS_NORMAS_CREATE_SUCCESS,
      data: response.data
    });

    if (response.data && response.data.arquivos) {
      yield FileService.uploadArquivos(data.arquivos, response.data.arquivos);
    }

    yield callback(true);
   
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function* update({ id, data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.put({ url: `procedimentos-normas/${id}`, data: { ...data, arquivos: FileService.getArquivosToUpload(data.arquivos) } });
     yield put({
      type: TypeActions.PROCEDIMENTOS_NORMAS_UPDATE_SUCCESS,
      data: response.data
    });

    if (response.data && response.data.arquivos) {
      yield FileService.uploadArquivos(data.arquivos, response.data.arquivos);
    }

    yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function* cancel({ id, data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.patch({ url: `procedimentos-normas/${id}/cancel`, data });
    yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações atualizadas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function* confirm({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.patch({ url: `procedimentos-normas/${id}/confirm` });
    yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações atualizadas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

// function* convocacaoReport({ filtro, callback }) {
//   try {
//     yield put({ type: LoaderTypeActions.LOADER_SHOW });
//     const response =  yield BaseService.execute({ 
//       url: 'PROCEDIMENTOS_NORMAS/report',
//       method: 'POST',
//       data: filtro,
//       options: {
//         responseType: 'blob'
//       }
//     });
//     yield fileDownload(response.data, 'Relatório Convocação.xlsx');
//     yield callback(response.data);
//     yield put({
//       type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
//       message: 'Relatório gerado com sucesso!'
//     });
//     yield put({ type: LoaderTypeActions.LOADER_HIDE });
//   } catch (error) {
//     yield console.log(error);
//     yield put({ type: LoaderTypeActions.LOADER_HIDE });
//     yield put({
//       type: ToastTypeActions.TOAST_MESSAGE_ERROR,
//       message: 'Erro ao exportar o relatório!'
//     });
//   }
// }

export default function* watchAuth() {
  yield takeLatest(TypeActions.PROCEDIMENTOS_NORMAS_FIND_ONE, findById);
  yield takeLatest(TypeActions.PROCEDIMENTOS_NORMAS_CREATE, create);
  yield takeLatest(TypeActions.PROCEDIMENTOS_NORMAS_UPDATE, update);
  yield takeLatest(TypeActions.PROCEDIMENTOS_NORMAS_CONFIRM_STATUS, confirm);
  yield takeLatest(TypeActions.PROCEDIMENTOS_NORMAS_CANCEL_STATUS, cancel);
  // yield takeLatest(TypeActions.PROCEDIMENTOS_NORMAS_REPORT, convocacaoReport);
}